import React, { Component } from 'react';
import Container from './Container';
import store from './_store';

class ServiceList extends Component {

  render() {
    return <Container store={store} />
  }
}

export default ServiceList;